import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../api/axiosBaseQuery";

export const reportApi = createApi({
  reducerPath: "reportApi",
  baseQuery: axiosBaseQuery,
  endpoints: (builder) => ({
    // Create a new report
    createReport: builder.mutation({
      query: (data) => ({
        url: "report/reports",
        method: "POST",
        data,
      }),
    }),

    // Create a new report version
    // createReportVersion: builder.mutation({
    //   query: (data) => ({
    //     url: "report/reports/versions",
    //     method: "POST",
    //     data,
    //   }),
    // }),

    // Fetch report versions by report ID
    fetchReportVersions: builder.query({
      query: (reportId) => ({
        url: `report/reports/${reportId}/versions`,
        method: "GET",
      }),
    }),
    fetchManagerByUser: builder.query({
        query: (employeeId) => ({
          url: `report/users/${employeeId}/manager`,
          method: "GET",
        }),
      }),
      sendEmail: builder.mutation({
        query: (data) => ({
          url: "email/send-email",
          method: "POST",
          data,
        }),
      }),
      generatePresignedUrl: builder.mutation({
        query: (data) => ({
          url: "report/generate-presigned-url/",
          method: "POST",
          data,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          }
        }),
      }),
      fetchVersionNumber: builder.query({
        query: (employeeId) => ({
          url: `report/report/${employeeId}/get-current-versionNumber`,
          method: "GET",
        }),
      }),
      fetchCurrentVersion: builder.query({
        query: (employeeId) => ({
          url: `report/users/${employeeId}/reports/current-version`,
          method: "GET",
        }),
      }),
//       createReport: builder.mutation({
//         query: (data) => {
//           const formData = new FormData();
//           formData.append('user_id', data.user_id);
//           formData.append('manager_id', data.manager_id);
//           formData.append('file', data.file);
//           formData.append('role', data.role);
  
//           return {
//             url: 'report/reports',
//             method: 'POST',
//             body: formData,
//             // No need to set 'Content-Type' header because the browser will set it correctly for FormData
//           };
//         },
//       }),
    
  }),
});

// Export hooks for usage in functional components
export const {
  useCreateReportMutation,
  useFetchReportVersionsQuery,
  useFetchManagerByUserQuery,
  useSendEmailMutation,
  useGeneratePresignedUrlMutation,
  useFetchVersionNumberQuery,
  useFetchCurrentVersionQuery,
  
} = reportApi;


export default reportApi;